import { EditStore } from "../EditCreate/EditStore";

import { names } from "./AssignPersonActions";
import { assertNumber } from "../../../utils/assert";
import { IncidentAssignment, SensorExcess } from "../../../../rest/Dashboard/interfaces";
import { Key } from "../../../../models";

export interface AssignPersonStoreState
{
    draft: IncidentAssignment;
    durations: number[];
}

export class AssignPersonStore extends EditStore<IncidentAssignment, AssignPersonStoreState>
{
    constructor()
    {
        super();
        this.register<number>(names.SET_DURATION, e => this.setDuration(e.payload));
        this.register<SensorExcess>(names.SET_SENSOR_EXCESS, e => this.getDafaultState(e.payload.IncidentId));
        this.register(names.REJECT_SENSOR_EXCESS, e => null);
    }

    setDuration = (duration: number): AssignPersonStoreState => {
        assertNumber(duration, 'number payload expected');
        return this.draft({ Duration: duration });
    };

    getDafaultState(incidentId: Key): AssignPersonStoreState
    {
        return {
            draft: {
                IncidentId: incidentId,
                Duration: 15,
            },
            durations: [15, 30, 45, 60, 120],
        };
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Home/AssignPersonStore.ts